import LegalLayout from './LegalLayout';

export default function TermsPage() {
  return (
    <LegalLayout title="服务条款">
      <p>使用 StatFlow 即表示你同意合理使用本统计服务，不得利用采集接口伪造、刷量或攻击他人网站。</p>
      <p>你应对自己添加的域名拥有管理权，并保证统计代码仅安装在已授权站点。</p>
      <p>请妥善保管登录账号与访问令牌，并自行做好数据备份与访问控制。</p>
    </LegalLayout>
  );
}
